import { Toast,Dialog } from 'vant'
//操作成功后的提示信息
function success(msg = '保存成功', callback = function() {}) {
	Toast({
	  type:'success',
	  message: msg,
	  duration:1000
	});
	setTimeout(function() {
		callback()
	}, 1000)
}
//操作失败的提示信息
function error(msg = '操作失败', callback = function() {}) {
	Toast({
	  type:'fail',
	  message: msg,
    icon:'warning-o',
	  duration:1500
	});
	setTimeout(function() {
		callback()
	}, 1500)
}
// 提示框
function confirm(
	title = '温馨提示',
	content = '确认执行此操作吗?',
	callback = () => {},
) {
  Dialog.confirm({
    title: title,
    message: content,
  }).then(() => {
      setTimeout(() => {
      		callback()
      }, 200)
  }).catch(() => {
  });
}



/**
 *
 * 对象参数转为url参数
 *
 */
function builderUrlParams(url, data) {
	if (typeof url == 'undefined' || url == null || url == '') {
		return ''
	}
	if (typeof data == 'undefined' || data == null || typeof data != 'object') {
		return ''
	}
	url += url.indexOf('?') != -1 ? '' : '?'
	for (var k in data) {
		url += (url.indexOf('=') != -1 ? '&' : '') + k + '=' + encodeURI(data[k])
	}
	return url
}


/**
 * 获取url参数
 *
 * @param {*} name
 * @param {*} [url=window.location.serach]
 * @returns
 */
function getQueryString(name, url) {
	var url = url || window.location.href
	var reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i')
	var r = url.substr(1).match(reg)
	if (r != null) {
		return r[2]
	}
	return null
}
function h5Copy(val){
	let result
	// #ifndef H5
	uni.setClipboardData({
	    data: val,
	    success() {
	       result = true
	    },
	    fail() {
	       result = false
	    }
	});
	// #endif
	// #ifdef H5
	let textarea = document.createElement("textarea")
	textarea.value = val
	textarea.readOnly = "readOnly"
	document.body.appendChild(textarea)
	textarea.select() // 选中文本内容
	textarea.setSelectionRange(0, val.length)
	result = document.execCommand("copy")
	textarea.remove()
	// #endif
	return result
}
export default {
	success,
	error,
	confirm,
	builderUrlParams,
	getQueryString,
	h5Copy
}



// WEBPACK FOOTER //
// ./src/libs/until.js